module.exports = __webpack_public_path__ + "img/icon_solution01.90536eee.png";